import helper from '@/libs/forms';
import STATES from '@/components/utils/address/resources/states.json';
import maritalStatusValues from '@/components/profile/sections/tabs/contact/resources/marital_status';


const contactMethodValues = [
  { name: 'Email', id: 'email' },
  { name: 'Phone Call', id: 'phone' },
  { name: 'Mail', id: 'mail' },
  { name: 'Fax', id: 'fax' },
  { name: 'Text', id: 'text' },
];

const contactMethodField = helper.simpleSelect(
  'Preferred Method of Contact', 'contactMethod', false, contactMethodValues, '-', 12,
);
contactMethodField.onValidated = (model, errors) => {
  const methodTypeMap = {
    fax: 'fax',
    text: 'mobile',
  };

  Object.keys(methodTypeMap).forEach((key) => {
    const phoneKey = methodTypeMap[key];
    if (model.contactMethod === key && !model.phones.find(phone => phone.type === phoneKey)) {
      errors.push(`Value not allowed when no phone with type "${phoneKey}" is informed!`);
    }
  });

  return errors;
};

const maritalStatusField = () => {
  const field = helper.simpleSelect(
    'Marital Status',
    'maritalStatus',
    true,
    maritalStatusValues,
    null,
    6,
  );
  field.hint = 'Unmarried (for single, divorced, widowed)';
  return field;
};

export default {
  schema: {
    fields: [
      helper.simpleInput('text', 'First Name', null, 'firstName', true, 6),
      helper.simpleInput('text', 'Last Name', null, 'lastName', true, 6),
      helper.simpleInput('text', 'Title', null, 'title', true, 6),
      helper.date('Date of Birth', null, 'dateOfBirth', true, 6, '01/01/1975', false, true),
      helper.ssn('SSN', 'ssn', null, true, 6),
      helper.simpleInput('text', 'Driver\'s License', null, 'driversLicense', true, 6),
      helper.simpleSelect('Driver\'s License State', 'driversLicenseState', true, STATES, null, 6),
      maritalStatusField(),
      contactMethodField,
    ],
  },
  options: helper.options('contact-basic-', false),
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/contact/schemas/basic.js